<template>
  <div>
    <v-dialog
      lazy
      scrollable
      persistent
      :value="show"
      :width="$store.state.common.largeDialogWidth"
      data-cy="create-edit-branding-dialog"
      @input="(v) => $emit('update:show', v)"
    >
      <v-card>
        <v-card-title class="pb-0">
          <v-layout column>
            <v-layout align-center>
              <span class="headline">
                {{ $t('createOrSkipBrandingDialogTitle') }}
              </span>
              <v-btn
                class="ml-auto mr-0 my-0"
                flat
                icon
                :title="$t('createOrSkipBrandingDialogButtonSkip')"
                @click="skip()"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-title>
        <v-card-text class="pb-0 px-0">
          <div class="pl-3 pr-5">
            <p class="subheading">
              {{ $t('createOrSkipBrandingDialogBody_1') }}
            </p>
            <p class="subheading">
              {{ $t('createOrSkipBrandingDialogBody_2') }}
            </p>
          </div>
        </v-card-text>
        <v-card-actions class="pt-2">
          <v-layout wrap>
            <v-btn
              block
              flat
              color="success"
              class="btn-choice mx-0"
              @click="create()"
            >
              <v-icon
                left
                large
              >
                add
              </v-icon>
              <v-layout
                column
                align-start
              >
                {{ $t('createOrSkipBrandingDialogButtonCreate') }}
                <small class="grey--text text--darken-1 nowrap">{{
                  $t('createOrSkipBrandingDialogButtonCreateHint')
                }}</small>
              </v-layout>
            </v-btn>
            <v-btn
              block
              flat
              color="msr"
              class="btn-choice mx-0"
              data-cy="create-or-skip-branding-dialog-skip-btn"
              @click="skip()"
            >
              <v-layout
                column
                align-end
              >
                {{ $t('createOrSkipBrandingDialogButtonSkip') }}
                <small class="grey--text text--darken-1 nowrap">{{
                  $t('createOrSkipBrandingDialogButtonSkipHint')
                }}</small>
              </v-layout>
              <v-icon
                right
                x-large
              >
                arrow_right
              </v-icon>
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    show: function (show) {
      // Focus namefield when creating a new Branding.
      if (this.isNewBranding) {
        this.$nextTick(() => this.$refs.namefield.focus());
      }
      // Reset when closing dialog.
      if (!show) {
        this.reset();
      }
    },
  },
  created() {},
  methods: {
    closeDialog() {
      this.$emit('update:show', false);
    },
    skip() {
      this.$emit('skip');
      this.closeDialog();
    },
    create() {
      this.$emit('create');
      this.closeDialog();
    },
  },
};
</script>

<style scoped>
.btn-choice {
  min-width: 312px;
  min-height: 72px;
  height: 100%;
  padding-top: 8px;
  padding-bottom: 8px;
}
.btn-choice >>> .v-btn__content {
  white-space: normal;
  text-transform: none;
  font-size: medium;
}
</style>



// WEBPACK FOOTER //
// src/components/CreateOrSkipBrandingDialog.vue